"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePaymentMethods = exports.updateHiddenPaymentMethods = exports.selectTermsUrl = exports.selectPublisherConfig = exports.selectDisplayGracePeriodError = exports.selectAdyenConfiguration = exports.publisherConfigSlice = exports.initialState = exports.init = exports.default = void 0;
var _toolkit = require("@reduxjs/toolkit");
const initialState = exports.initialState = {
  publisherId: '',
  offerId: '',
  paymentMethods: [],
  visiblePaymentMethods: [],
  hiddenPaymentMethods: [],
  isPayPalHidden: false,
  adyenConfiguration: null,
  displayGracePeriodError: false,
  termsUrl: '',
  enable3DSRedirectFlow: false
};
const publisherConfigSlice = exports.publisherConfigSlice = (0, _toolkit.createSlice)({
  name: 'publisherConfig',
  initialState,
  reducers: {
    init: (state, action) => ({
      ...state,
      ...action.payload
    }),
    updatePaymentMethods: (state, action) => {
      state.paymentMethods = action.payload;
    },
    updateHiddenPaymentMethods: (state, action) => {
      state.hiddenPaymentMethods = action.payload;
    }
  }
});
const selectAdyenConfiguration = state => state.publisherConfig.adyenConfiguration;
exports.selectAdyenConfiguration = selectAdyenConfiguration;
const selectPublisherConfig = state => state.publisherConfig;
exports.selectPublisherConfig = selectPublisherConfig;
const selectDisplayGracePeriodError = state => state.publisherConfig.displayGracePeriodError;
exports.selectDisplayGracePeriodError = selectDisplayGracePeriodError;
const selectTermsUrl = state => state.publisherConfig.termsUrl;
exports.selectTermsUrl = selectTermsUrl;
const {
  init,
  updatePaymentMethods,
  updateHiddenPaymentMethods
} = publisherConfigSlice.actions;
exports.updateHiddenPaymentMethods = updateHiddenPaymentMethods;
exports.updatePaymentMethods = updatePaymentMethods;
exports.init = init;
var _default = exports.default = publisherConfigSlice.reducer;